import { FunctionBrick, registerBrick } from 'olympe'

export default class StyleButtons extends FunctionBrick {
  /**
   * Executed every time an input (class) gets updated.
   * Note that this method will _not_ be executed if an input value is undefined.
   *
   * @protected
   * @param {BrickContext} context
   * @param {string} class
   * @param {function(string)} setStyle
   */
  onUpdate(context, [type], [setStyle]) {
    /* Write your code here. You have to implement this method ! */
    let style = {
      color: 'white',
      font: 'Roboto',
      backgroundColor: 'orange',
    }

    // Set the variations
    switch (type) {
      case 'primary':
        style.color = '#303030'
        break
      case 'secondary':
        style.color = 'orange'
        style.backgroundColor = 'grey'
        break
      case 'tertiary':
        style.color = 'rgba(123,210,40,0.9)'
        break

      default:
        break
    }
    setStyle(JSON.stringify(style))
  }
}

registerBrick('017a19c824be770f7f4d', StyleButtons)
